document.addEventListener("DOMContentLoaded", function () {
  window.initializeSwiperWhenVisible('.block__footer-review-slider', () => new Swiper('.block__footer-review-slider', {
    loop: true,
    slidesPerView: "auto",
    paginationClickable: false,
    spaceBetween: 10,
    freeMode: false,
    autoplay: {
      delay: 0,
    },
    speed: 7000,
    breakpoints: {
      749: {
        spaceBetween: 20,
      },
    },
  }));

  const headers = document.querySelectorAll(".block__footer-menu h4");

  function toggleAccordion(header) {
    const menuList = header.nextElementSibling;

    // Toggle active class
    header.classList.toggle("active");

    // Toggle accordion with smooth transition
    if (menuList.style.maxHeight) {
      menuList.style.maxHeight = null;
    } else {
      menuList.style.maxHeight = menuList.scrollHeight + "px";
    }
  }

  function setupAccordion() {
    if (window.innerWidth < 991) {
      headers.forEach((header) => {
        const menuList = header.nextElementSibling;

        // Initially collapse all
        menuList.style.maxHeight = null;

        // Ensure only one listener per element
        header.removeEventListener("click", header._accordionHandler);
        header._accordionHandler = () => toggleAccordion(header);
        header.addEventListener("click", header._accordionHandler);
      });
    } else {
      // Reset everything on wider screens
      headers.forEach((header) => {
        const menuList = header.nextElementSibling;
        menuList.style.maxHeight = null;
        header.classList.remove("active");
        header.removeEventListener("click", header._accordionHandler);
      });
    }
  }

  // Initial setup
  setupAccordion();

  // Re-evaluate on resize
  window.addEventListener("resize", setupAccordion);
});
